var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8153 0.194146C15.7252 0.1046 15.6114 0.042601 15.4872 0.0154398C15.3631 -0.0117214 15.2337 -0.00291591 15.1144 0.0408209L0.430735 5.37388C0.3041 5.42185 0.195075 5.50717 0.118139 5.6185C0.0412041 5.72983 0 5.86191 0 5.99718C0 6.13246 0.0412041 6.26453 0.118139 6.37586C0.195075 6.48719 0.3041 6.57251 0.430735 6.62048L6.83817 9.18035L9.40114 15.58C9.4493 15.7009 9.53184 15.8052 9.63858 15.8798C9.74532 15.9544 9.8716 15.9962 10.0018 16C10.1367 15.9972 10.2676 15.9537 10.3772 15.8752C10.4868 15.7966 10.57 15.6868 10.6159 15.56L15.9554 0.894111C16.0009 0.776167 16.0119 0.647743 15.987 0.523812C15.9622 0.39988 15.9026 0.285548 15.8153 0.194146ZM10.0018 13.4668L8.13968 8.80037L11.3367 5.6072L10.3956 4.66725L7.17189 7.88708L2.5265 6.00051L14.2267 1.78073L10.0018 13.4668Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareArrow);
export default __webpack_public_path__ + "static/media/share-arrow.3055c5f515edbd73f665331f51c641fa.svg";
export { ForwardRef as ReactComponent };